export default {
    methods: {
        /**
         * Requires the input of the remaining seconds as well as a type to format the current timer.
         *
         * @param remainingSeconds - Remaining time on timer
         * @param type - Default is set to inactivity, which is the main component.  If type is anything
         */
        formatTime(remainingSeconds, type = 'inactivity') {
            //hopefully no one has the reminder dialog configured for more than 1 day...
            const format = (remainingSeconds >= 3600 ? "HH:" : "") + "mm:ss";

            if (type === 'inactivity') {
                this.$store.commit('sessionTimeout/updateFormattedInactivityTime', (moment.utc(moment.unix(remainingSeconds)).format(format)));
            } else {
                this.$store.commit('sessionTimeout/updateFormattedLogoutTime', (moment.utc(moment.unix(remainingSeconds)).format(format)));
            }
        },

        getCurrentTime() {
            return moment.utc().unix().valueOf();
        },

        logout(saveURI = true) {
            const redirectStr = saveURI ? '?ref=' + btoa(window.location.pathname)  + '&timedout=1': '?timedout=1';
            window.location.href = '/logout' + redirectStr;
        },

        userLogout() {
            this.logout(false);
        },
    }
}